import store from "../store"

const defaultState = {
    byIds: {},
    allIds: [],
    lastSuccessGetResult: [],
    loading: false,
    error: undefined
} 

const videoReducer = (state = defaultState, action) => {
    switch(action.type) {
        case "GET_VIDEOS_REQUEST": 
            return { ...state, loading: true }
        case "GET_VIDEOS_SUCCESS":
            let { videos } = action.payload.data
            
            console.log("GET_VIDEOS",videos)
            for (let floor of videos) {
                state.byIds[floor.id] = floor
                if (state.allIds.indexOf(floor.id) === -1) state.allIds.push(floor.id);
            }
            return { 
                lastSuccessGetResult: [ ...action.payload.data.videos ],
                error: undefined, 
                loading: false, 
                allIds: [ ...state.allIds ], 
                byIds: { ...state.byIds } 
            }
        case "GET_VIDEOS_FAILED":
            return { ...state, error: action.error, loading: false, allIds: [ ...state.allIds ], byIds: { ...state.byIds } }
        default:
            return state;
    }
}

export default videoReducer;